<template>
  <div ref="containerRef"></div>
</template>

<script>
import {defineComponent, getCurrentInstance, onMounted, watch} from '@vue/composition-api'

import {useMicrofrontendWithUpdate} from '@/composables'
import {loadCreateAppointmentModal} from '@/utils/microfrontend-loader'

export default defineComponent({
  name: 'AppointmentFormModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    prefilledContact: {
      type: Object,
      required: false,
      default: undefined,
    },
    disableContactFields: {
      type: Boolean,
      required: false,
      default: false,
    },
    dealerContactId: {
      type: String,
      required: false,
      default: undefined,
    },
    preselectedLeadId: {
      type: String,
      required: false,
      default: undefined,
    },
    onSubmit: {
      type: Function,
      required: true,
    },
  },
  emits: ['close'],
  setup(props, {emit}) {
    const instance = getCurrentInstance()
    const store = instance?.proxy.$store
    const i18n = instance?.proxy.$i18n

    const {containerRef, buildContext, mountWithUpdate, update} = useMicrofrontendWithUpdate()

    const context = () => {
      return buildContext('/sales-appointments', {
        isOpen: props.isOpen,
        onClose: () => emit('close'),
        onSubmit: props.onSubmit,
        prefilledContact: props.prefilledContact,
        disableContactFields: props.disableContactFields,
        dealerContactId: props.dealerContactId,
        preselectedLeadId: props.preselectedLeadId,
      })
    }

    const mountModal = async () => {
      try {
        await mountWithUpdate(loadCreateAppointmentModal, context())
      } catch (err) {
        console.error('Error loading CreateAppointmentModal:', err)
        store?.dispatch('showAlertError', i18n?.t('common.loadError'))
        emit('close')
      }
    }

    onMounted(() => mountModal())

    watch(
      () => props.isOpen,
      () => update(context()),
    )

    return {containerRef}
  },
})
</script>
